import { render, staticRenderFns } from "./VoiceSearchPop.vue?vue&type=template&id=7126cf9a&"
import script from "./VoiceSearchPop.vue?vue&type=script&lang=js&"
export * from "./VoiceSearchPop.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSearchPop.vue?vue&type=style&index=0&id=7126cf9a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports